module.exports =
{

  _init: function ()
  {
    APPLICATION._APPLICATION.processLinks('#area-codes', 'AreaCode', 'areaCodes')
  }

}